import { Route } from '@angular/router';

import { pagesRoutes } from '@pkp-g/pages';
import { authGuard } from './core';

export const APP_ROUTES: Route[] = [
  // {
  //   path: 'auth',
  //   loadComponent: () => import('./pages/auth').then(m => m.AuthPage),
  //   title: 'UIMS - Parking Gate',
  // },
  {
    path: '',
    loadComponent: () => import('./pages/pages.component').then(m => m.PagesComponent),
    title: 'UIMS - Parking Gate',
    canActivate: [authGuard],
    children: [...pagesRoutes],
  },
];
